/** PriceIVA=false (default) → documento sin IVA → sinIva=true en API */
export const sinIvaFromPriceIva = (priceWithIva) => !priceWithIva

export const appendSinIvaQueryParam = (queryParams, sinIva) => {
  if (sinIva) {
    queryParams.append('sinIva', 'true')
  }
}
